export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_REQUEST_SUCCESS = 'AUTH_LOGIN_REQUEST_SUCCESS';
export const AUTH_LOGIN_REQUEST_FAILED = 'AUTH_LOGIN_REQUEST_FAILED';
export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST'